export function getObstacleIcon(L, o, outcome, showObsLabels = true) {
    let iconUrl = '/symbols/obstacle_orange.svg'; // Unassessed by default

    if (outcome) {
        const isPen = typeof outcome === 'string'
            ? ['penetrated', 'yes', 'impact'].some(x => outcome.toLowerCase().includes(x))
            : outcome === true; // If boolean true passed

        const isClear = typeof outcome === 'string'
            ? ['clear', 'not penetrated', 'no'].some(x => outcome.toLowerCase().includes(x))
            : outcome === false;

        if (isPen) iconUrl = '/symbols/obstacle_red.svg';
        else if (isClear) iconUrl = '/symbols/obstacle_green.svg';
    }

    const obsName = (o?.name || o?.obstacle_name || '').replace(/"/g, '&quot;');
    const SZ = 20; // icon image size in px
    const HALF = SZ / 2;

    return L.divIcon({
        className: '',
        html: `
            <div style="position:relative; width:${SZ}px; height:${SZ}px;">
                ${showObsLabels && obsName ? `<div style="position:absolute; bottom:100%; left:50%; transform:translateX(-50%); margin-bottom:2px; font-size:10px; font-weight:900; color:#fff; background:rgba(0,0,0,0.55); padding:1px 4px; border-radius:3px; text-shadow:0 0 4px #000; white-space:nowrap; pointer-events:none;">${obsName}</div>` : ''}
                <img src="${iconUrl}?v=1" style="width:${SZ}px; height:${SZ}px; display:block;" alt="Obs" />
            </div>
        `,
        iconSize: [SZ, SZ],
        iconAnchor: [HALF, HALF]
    });
}

// Split-colour halo for a shielding candidate that's BOTH raw-elevation-red
// (taller than the project's own worst point) AND confirmed to genuinely
// penetrate a real surface at its own position (yellow) — two independent,
// true facts about the same marker that a single fill colour can't show at
// once. Rendered as a divIcon halo sitting on top of the plain circleMarker
// useShield.js already drew at the same coordinate (divIcons live in
// Leaflet's markerPane, above the circleMarker's overlayPane, so no z-index
// juggling needed), not a replacement for it.
export function getShieldComboIcon(L, colorA = '#e84040', colorB = '#FFE14D') {
    const SZ = 20;
    const HALF = SZ / 2;
    const svg = `<svg width="${SZ}" height="${SZ}" viewBox="0 0 ${SZ} ${SZ}">` +
        `<path d="M${HALF},1 A${HALF - 1},${HALF - 1} 0 0 1 ${HALF},${SZ - 1} Z" fill="${colorA}" stroke="#fff" stroke-width="1"/>` +
        `<path d="M${HALF},1 A${HALF - 1},${HALF - 1} 0 0 0 ${HALF},${SZ - 1} Z" fill="${colorB}" stroke="#fff" stroke-width="1"/>` +
        `</svg>`;
    return L.divIcon({
        className: '',
        html: svg,
        iconSize: [SZ, SZ],
        iconAnchor: [HALF, HALF],
    });
}

export function getArpIcon(L, arp, showArpLabels = true) {
    const ARP_ICON = '#3a8ac4';
    const icao = (arp?.icao || '').toUpperCase();
    const DOT = 19; // 14px circle + 2.5px border each side
    const HALF = Math.round(DOT / 2);

    return L.divIcon({
        className: '',
        html: `
            <div style="position:relative; width:${DOT}px; height:${DOT}px;">
                ${showArpLabels && icao ? `<div style="position:absolute; bottom:100%; left:50%; transform:translateX(-50%); margin-bottom:2px; font-size:11px; font-weight:900; color:#ff9800; text-shadow:1px 1px 0 #000, -1px -1px 0 #000, 1px -1px 0 #000, -1px 1px 0 #000, 0 0 5px rgba(0,0,0,0.8); white-space:nowrap; pointer-events:none;">${icao}</div>` : ''}
                <div style="width:14px;height:14px;border-radius:50%;background:${ARP_ICON};border:2.5px solid #fff;box-shadow:0 0 8px ${ARP_ICON}99;"></div>
            </div>
        `,
        iconSize: [DOT, DOT],
        iconAnchor: [HALF, HALF]
    });
}
